import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiArrowRight } from "react-icons/fi";

export const BookSection = () => {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language === "en" || i18n.language === "EN";

  // English and Japanese titles use different weights/sizes per design
  const titleTypography = isEnglish
    ? "tw:font-normal tw:text-[26px]"
    : "tw:font-medium tw:text-[22px]";

  return (
    <div
      className={`tw:relative tw:bg-[url(https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/book-your-journey-background.png)] tw:h-[420px] tw:lg:h-[388px] tw:bg-center tw:bg-cover tw:bg-no-repeat`}
    >
      <div class="tw:bg-[linear-gradient(202.02deg,rgba(40,40,40,0.32)_46.74%,rgba(0,0,0,0.8)_82.22%)] tw:lg:bg-[linear-gradient(268.88deg,rgba(40,40,40,0.352)_61.98%,rgba(0,0,0,0.88)_95.88%)] tw:absolute tw:w-full tw:h-full tw:top-0 tw:left-0"></div>
      <div className="tw:absolute tw:px-6 tw:lg:px-0 tw:lg:ml-[89px] tw:bottom-8 tw:text-white tw:top-0 tw:left-0 tw:lg:w-[520px] tw:lg:h-full tw:lg:flex tw:lg:justify-center tw:lg:flex-col">
        <div className={`tw:font-libre-caslon-display ${titleTypography} tw:leading-[26px] tw:lg:leading-[35px] tw:pt-45 tw:md:pt-60 tw:lg:pt-0`}>
          {t("BookBanner.Title")}
        </div>
        <div className="tw:mt-[22px] tw:font-hanken-grotesk tw:font-normal tw:text-[15px] tw:leading-[20px]">
          {t("BookBanner.Description")}
        </div>
        <div>
          <Link
            to={isEnglish ? "/en/book" : "/jp/book"}
            className="tw:h-[50px] tw:w-full tw:mt-[30px] tw:bg-[#D4B055] tw:rounded-md tw:text-white tw:flex tw:items-center tw:justify-center tw:gap-[10px] tw:leading-5 tw:px-6 tw:w-full tw:hover:tw:bg-[#b99844] tw:transition"
          >
            <div className="tw:font-hanken-grotesk tw:font-bold tw:text-sm tw:!text-white">
              {t("BookBanner.ButtonText")}
            </div>
            <FiArrowRight size={24} color="#ffffff" />
          </Link>
        </div>
      </div>
    </div>
  );
};
